module.exports = __webpack_public_path__ + "img/product-s618-2000.500aaa86.png";